/**
 * ACC_ThrivinUK_CartDrawer_33 — socks gate (theme asset)
 *
 * Hook (1 line) at top of reconcileCart in sections/free-socks.liquid:
 *   if (window.__ACC33Socks && (await window.__ACC33Socks.gate(opts))) return;
 *
 * When test active + cart < socksGoal (V1 £100 / V2 £110) → strip + skip reconcile.
 * When test active + cart ≥ goal → allow free-socks.liquid.
 * When test inactive → no-op (return false).
 *
 * Match order: props → gift variant_ids from [data-free-gift-auto] → known handles.
 */
(function () {
  'use strict';

  var TEST_CLASS = 'ACC_ThrivinUK_CartDrawer_33';
  var TEST_CLASS_V2 = 'ACC_ThrivinUK_CartDrawer_33_v2';
  var REMOVED_FLAG_KEY = '__freeGiftRemovedInSession';
  var SOCKS_PROP = '_free_gift_socks';
  var DEFAULT_GOAL = 100;
  var SOCKS_HANDLES = ['our-gift-for-you-free-white-silk-socks', 'free-thrivin-silk-socks-white'];

  function isActive() {
    if (window.__ACC33 && typeof window.__ACC33.active === 'function') {
      return window.__ACC33.active();
    }
    return (
      document.documentElement.classList.contains(TEST_CLASS) ||
      document.documentElement.classList.contains(TEST_CLASS_V2) ||
      (document.body &&
        (document.body.classList.contains(TEST_CLASS) || document.body.classList.contains(TEST_CLASS_V2)))
    );
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getSpent(cart) {
    var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    return Number(cart && cart.total_price ? cart.total_price : 0) / 100 / rate;
  }

  function socksGoal() {
    return (window.__ACC33 && window.__ACC33.socksGoal) || DEFAULT_GOAL;
  }

  function propTrue(value) {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function itemHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    var url = item.url || '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function isZeroPriceLine(item) {
    if (!item) return false;
    var final = Number(item.final_line_price);
    var line = Number(item.line_price);
    if (!isNaN(final)) return final === 0;
    if (!isNaN(line)) return line === 0;
    return false;
  }

  function getSocksGiftVariantIds() {
    var block = document.querySelector('[data-free-gift-auto]');
    if (!block) return [];
    try {
      return JSON.parse(block.dataset.giftVariantIds || '[]').map(String);
    } catch (e) {
      return [];
    }
  }

  function isSocksGiftLine(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (propTrue(props[SOCKS_PROP])) return true;
    if (!isZeroPriceLine(item)) return false;

    var variantIds = getSocksGiftVariantIds();
    if (variantIds.length && variantIds.indexOf(String(item.variant_id)) !== -1) return true;

    return SOCKS_HANDLES.indexOf(itemHandle(item)) !== -1;
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js?v=' + Date.now(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  function findSocksLines(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(isSocksGiftLine);
  }

  /* Silent — theme onCartChange needs cart.sections; use cart:refresh instead. */
  function removeLine(key) {
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /**
   * @returns {Promise<boolean>} true = skip free-socks reconcile
   */
  async function gate(opts) {
    opts = opts || {};
    if (!isActive()) return false;

    try {
      var cart = opts.cart || (await fetchCart());
      var spent = getSpent(cart);
      var goal = socksGoal();

      if (spent >= goal) {
        /* Allow original free-socks to add; clear block from below-threshold runs */
        sessionStorage.removeItem(REMOVED_FLAG_KEY);
        return false;
      }

      /* Below £100 — block qty auto-add and strip any socks gift lines */
      sessionStorage.setItem(REMOVED_FLAG_KEY, '1');
      var lines = findSocksLines(cart);
      var removed = false;
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].key) {
          await removeLine(lines[i].key);
          removed = true;
        }
      }
      if (removed) refreshCartDrawer();
      return true;
    } catch (e) {
      console.error('[ACC33 socks gate]', e);
      return true;
    }
  }

  window.__ACC33Socks = { gate: gate };
})();
